import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ClientFooterComponent } from '@core/components/layout/client/client-footer/client-footer.component';
import { HeaderComponent } from '@core/components/layout/header/header.component';

import { ClientConfigService } from '@core/services/client-config/client-config.service';
import { StatusBannerStripComponent } from '@shared/components/status-banner-strip/status-banner-strip.component';
import { Button } from 'primeng/button';
import { SpeedDialModule } from 'primeng/speeddial';
import { BasePageLayoutComponent } from '../base-page-layout.component';

@Component({
  selector: 'd2d-page-layout',
  imports: [
    RouterOutlet,
    HeaderComponent,
    ClientFooterComponent,
    Button,
    SpeedDialModule,
    StatusBannerStripComponent,
  ],
  templateUrl: './page-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page-layout.component.scss',
})
export class PageLayoutComponent extends BasePageLayoutComponent implements OnInit {
  private readonly clientConfigService = inject(ClientConfigService);

  constructor() {
    super('PageLayout');
    this.clientConfigService.unSetConfig();
  }

  ngOnInit() {
    this.loadMenuSettings(0);
    this.subscribeToSettingsChanges(0);
  }
}
